export class DashboardStatistic {
  inspectionsLastMonthCount: number;
  inspectionsOnReviewCount: number;
  inspectionsUpcoming: InspectionStatistic[];
  inspectionInProgress: InspectionStatistic[];
}

export class InspectionStatistic {
  name: string;
  id: string;
  customer: string;
  equipment: string;
  serial: string;
  startDate: Date;
  days: number;
  technicianId: string;
  technicianName: string;
}
